import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import ProjectReport from "./ProjectReport/ProjectReport";
import './Projects.css';

const Projects = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDocs(collection(db, "project_reports"))
            .then((snapshot) => {
                setReports(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="projects-section">
            <div className="projects-header">
                <span className="label-sub">Was wir tun</span>
                <h1>Unsere Projekte</h1>
            </div>
            {loading
                ? <p className="projects-loading">Projekte werden geladen…</p>
                : reports.length === 0
                    ? <p className="projects-empty">Demnächst verfügbar.</p>
                    : reports.map(report => <ProjectReport key={report.id} reportData={report} />)
            }
        </div>
    );
};

export default Projects;
